import { HelpArticleMeta } from './helpCenter';

/**
 * Which help articles a user sees (#2685) — the pure rule, kept apart from the
 * hook in `helpVisibility.ts` so it can be tested without the auth stack.
 *
 * An article whose `requires` names a gate below is shown only to users who
 * pass it. Every other `requires` value (`accessManagement`,
 * `checkInCheckOut`, …) is information for the reader, not a gate — an
 * operator without the add-on may well read what it would give them.
 */
export interface HelpViewer {
    /** Same answer as the cross-tenant view's own gate (`useCanViewAllTenants`). */
    canViewAllTenants: boolean;
}

const GATES: Record<string, (viewer: HelpViewer) => boolean> = {
    allTenantView: (viewer) => viewer.canViewAllTenants,
};

export const isArticleVisible = (article: HelpArticleMeta, viewer: HelpViewer): boolean =>
    article.requires.every((requirement) => {
        const gate = GATES[requirement];
        return gate ? gate(viewer) : true;
    });
